/**
 * Storybook Theme Wrapper
 *
 * WHY THIS FILE EXISTS:
 * The main theme file (theme/index.ts) uses TypeScript module augmentation syntax
 * (declare module '@mui/material/styles') which Storybook's webpack configuration
 * has difficulty transpiling. This JavaScript wrapper imports and re-exports the theme
 * to avoid TypeScript compilation issues while still using the modern hubThemeLight theme.
 *
 * USAGE:
 * Import this file in Storybook configuration files instead of importing theme/index.ts directly.
 *
 * MIGRATION NOTE:
 * Once Storybook's TypeScript support improves or if we upgrade to a version that handles
 * module augmentation properly, this wrapper can be removed and preview.js can import
 * directly from theme/index.ts.
 */

import { createHubThemeLight } from './index.ts';

// Export the modern hubThemeLight theme
export const hubThemeLight = createHubThemeLight();
export { createHubThemeLight };
